import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SommelierDto, SommelierService } from '@proxy/sommeliers';
import { environment } from 'src/environments/environment';
import { StorageService } from '../shared/services/storage.service';
import { SelectedSommelierService } from '../shared/services/selected-sommelier.service';

@Component({
  selector: 'app-sommelier-profile',
  templateUrl: './sommelier-profile.component.html',
  standalone: false
})
export class SommelierProfileComponent implements OnInit {
  sommelier: SommelierDto;
  imageUrl: string | null = null;
  whatsAppHref: string | null = null;
  fullLink: string;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private sommelierService: SommelierService,
    private storageService: StorageService,
    private slugService: SelectedSommelierService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const slug = params.get('slug');
      if (slug) {
        this.slugService.setSlug(slug);
        this.loadSommelier(slug);
      }
    });
  }

  private loadSommelier(slug: string) {
    this.sommelierService.getBySlug(slug).subscribe({
      next: (data) => {
        // Si no hay datos o el sommelier no existe, redirigir al login
        if (!data || !data.slug) {
          this.redirectToLogin();
          return;
        }

        this.sommelier = data;

        this.fullLink = `${environment.application.baseUrl}/${this.sommelier.slug}`;

        if (this.sommelier.fileAttachmentId) {
          this.storageService.getImage(this.sommelier.fileAttachmentId).subscribe(blob => {
            this.imageUrl = URL.createObjectURL(blob);
          });
        }

        // link de WhatsApp
        this.whatsAppHref = this.buildWhatsAppLink(
          this.sommelier.phoneNumber,
          this.getDefaultWaMessage()
        );
      },
      error: (error) => {
        // Si hay un error (slug no existe), redirigir al login
        console.error('Error al cargar sommelier:', error);
        this.redirectToLogin();
      }
    });
  }

  private redirectToLogin() {
    // Redirigir al landing (home) cuando hay una URL errónea
    // El landing manejará la redirección según el estado de autenticación del usuario
    this.router.navigate(['/']);
  }

  viewCatalog() {
    if (!this.sommelier?.slug) return;
    this.router.navigate([`/${this.sommelier.slug}/catalog`]);
  }

  contact() {
    if (this.whatsAppHref) {
      window.open(this.whatsAppHref, '_blank');
    }
  }


  private getDefaultWaMessage(): string {
    return '¡Hola! ¿Cómo estás? Te escribo desde WinePassport y me interesó mucho tu catálogo.\n\n¿Podemos coordinar y confirmar disponibilidad? ¡Gracias!';
  }

  private buildWhatsAppLink(raw?: string | null, message?: string | null): string | null {
    if (!raw) return null;

    let p = raw.startsWith('+')
      ? raw.slice(1)                          // E.164 guardado: solo quitar '+'
      : raw.replace(/\D+/g, '');             // fallback: solo dígitos

    if (p.startsWith('00')) p = p.slice(2);

    const base = `https://wa.me/${p}`;
    const txt = message ? encodeURIComponent(message) : '';
    return txt ? `${base}?text=${txt}` : base;
  }
}
